import React from "react";
import PageButton from "../../components/PageButton/PageButton";

//import Assets
import success from "../../assets/icons/success.png";

//React Router
import { Link } from "react-router-dom";

//Style

import "./successfulCreation.scss";

const SuccessfulCreation = () => {
  return (
    <div className="successfulCreation__container">
      <div className="successfulCreation__message">
        <img src={success} alt="exito" />
        <p className="successfulCreation__message__text">
          El producto se ha creado con éxito.
        </p>
        <Link to={`/admin`}>
          <PageButton
            filled
            className="successfulCreation__message__button"
            label="Volver"
          />
        </Link>
      </div>
    </div>
  );
};

export default SuccessfulCreation;
